<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Kidney Specific Details
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="stagedKidney"
              disabled
              label="Staged Kidney"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>
    
        <!-- <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="eGFR"
              disabled
              label="EGFR"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="egfrDate"
              disabled
              label="EGFR Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="A1C"
              disabled
              label="A1C"
            />
          </div>
        </div> -->
   
        <div class="row">
          <!-- <div class="col-2">
            <ADSTextInput
              v-model="A1CDate"
              disabled
              label="A1C Date"
            />
          </div> -->

          <div class="col-2">
            <ADSTextInput
              v-model="generalComments"
              disabled
              label="General Comments"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="kidneyPairedDonation"
              disabled
              label="Kidney Paired Donations"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="listExchange"
              disabled
              label="List Exchange"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="listExchangeDate"
              disabled
              label="List Exchange Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="previousLivingDonor"
              disabled
              label="Previous Living Donor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="preEmptive"
              disabled
              label="Pre-Emptive"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="donationDate"
              disabled
              label="Donation Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "KidneySpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      stagedKidney: this.getStagedKidney( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle )?.toString(),
      serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle )?.substring( 0,10 ),
      // eGFR: this.getEGFR( this.patientBundle ),
      // egfrDate: this.getEGFRDate( this.patientBundle ),
      // A1C: this.getA1C( this.patientBundle ),
      // A1CDate: this.getA1CDate( this.patientBundle ),
      generalComments: this.getGeneralComments( this.patientBundle ),
      kidneyPairedDonation: this.getKidneyPairedDonation( this.patientBundle ),
      listExchange: this.getListExchange( this.patientBundle ),
      listExchangeDate: this. getListExchangeDate( this.patientBundle ),
      previousLivingDonor: this.getPreviousLivingDonor( this.patientBundle ),
      donationDate: this.getDonationDate( this.patientBundle ),
      preEmptive: this.getPreEmptive( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getStagedKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let stagedKidney = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#296' ) ) ;
      if( stagedKidney && stagedKidney[ 0 ] ) {
        return _.get( stagedKidney[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
    },
    containsCreatinine( observation ) {
       const data = observation.resource?.code?.coding?.filter( ( item ) => item.code === '14682-9' );
       if( data && data.length > 0 )
       return true;
      },
    getSerumCreatinine( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinine = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinine && serumCreatinine[ 0 ] ) {
        return _.get( serumCreatinine[ 0 ], 'resource.valueQuantity.value' );
      } 
      }
    },
    getSerumCreatinineDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinineDate = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinineDate && serumCreatinineDate[ 0 ] ) {
        return _.get( serumCreatinineDate[ 0 ], 'resource.issued' );
      } 
      }
    },
    // getEGFR( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let egfr = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'laboratory' && n.resource?.code.coding[ 0 ].code === '62238-1' ) ) ;
    //   if( egfr && egfr[ 0 ]?.resource?.valueQuantity?.value && egfr[ 0 ]?.resource?.valueQuantity?.unit ) {
    //     return egfr[ 0 ].resource.valueQuantity.value + ' ' + egfr[ 0 ].resource.valueQuantity.unit;
    //   } 
    //   }
    // },
    // getEGFRDate( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let egfrDate = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'laboratory' && n.resource?.code.coding[ 0 ].code === '62238-1' ) ) ;
    //   if( egfrDate && egfrDate[ 0 ]?.resource?.issued ) {
    //     return egfrDate[ 0 ].resource.issued
    //   } 
    //   }
    // },
    // getA1C( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let A1C = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'laboratory' && n.resource?.code.coding[ 0 ].code === '4548-4' && n.resource?.code.coding[ 1 ].code === 'HBA1CP' ) ) ;
    //   if( A1C && A1C[ 0 ]?.resource?.valueQuantity?.value && A1C[ 0 ]?.resource?.valueQuantity?.unit ) {
    //     return A1C[ 0 ].resource.valueQuantity.value + ' ' + A1C[ 0 ].resource.valueQuantity.unit;
    //   } 
    //   }
    // },
    // getA1CDate( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let A1CDate = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'laboratory' && n.resource?.code.coding[ 0 ].code === '4548-4' && n.resource?.code.coding[ 1 ].code === 'HBA1CP' ) ) ;
    //   if( A1CDate && A1CDate[ 0 ]?.resource?.issued ) {
    //     return A1CDate[ 0 ].resource.issued
    //   } 
    //   }
    // },
    getGeneralComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let generalComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16531' ) ) ;
      if( generalComments && generalComments[ 0 ] ) {
        return _.get( generalComments[ 0 ], 'resource.component[0].valueString' );
      } 
      }
    },
    getKidneyPairedDonation( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let kidneyPairedDonation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#297' ) ) ;
      if( kidneyPairedDonation && kidneyPairedDonation[ 0 ] ) {
        return _.get( kidneyPairedDonation[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
    },
    getListExchange( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let listExchange = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#299' ) ) ;
      if( listExchange && listExchange[ 0 ] ) {
        return _.get( listExchange[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
    },
    getListExchangeDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let listExchangeDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#300' ) ) ;
      if( listExchangeDate && listExchangeDate[ 0 ] ) {
        return _.get( listExchangeDate[ 0 ], 'resource.component[0].valueDateTime' )
      } 
      }
    },
    getPreviousLivingDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let previousLivingDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#301' ) ) ;
      if( previousLivingDonor && previousLivingDonor[ 0 ] ) {
        return _.get( previousLivingDonor[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
    },
    getDonationDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let donationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#303' ) ) ;
      if( donationDate && donationDate[ 0 ] ) {
        return _.get( donationDate[ 0 ], 'resource.component[0].valueDateTime' )
      } 
      }
    },
    getPreEmptive( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let preEmptive = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#184' ) ) ;
      if( preEmptive && preEmptive[ 0 ] ) {
        return _.get( preEmptive[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 560px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
